import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";

interface ProjectCardProps {
  title: string;
  description: string;
  images?: string[]; // Sada podržava array
  image?: string; // Za projekte koji imaju samo jednu sliku
  url?: string;
}

export const ProjectCard = ({ title, description, images, image, url }: ProjectCardProps) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  useEffect(() => {
    if (images && images.length > 1) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [images]);

  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="bg-gray-800/40 backdrop-blur-lg rounded-xl overflow-hidden border border-gray-700/50 group"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={images ? images[currentImageIndex] : image} 
          alt={title}
          className="w-full h-full object-contain transition-opacity duration-500"
        />
        
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/60 via-gray-900/90 to-gray-900/95 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
          <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
            <p className="text-gray-200 mb-6">{description}</p>
            
          </div>
        </div></div>
      <div className="p-6 bg-gray-800/40 group-hover:bg-gray-800/60 transition-colors duration-300">
        <h3 className="text-xl font-semibold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
          {title}
        </h3>
       
        {url && (
          <div className="mt-2 flex items-center gap-2">
            <motion.a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-white flex items-center gap-1 transition-colors"
              whileHover={{ x: 2 }}
            >
              View Project <ExternalLink className="w-3 h-3" />
            </motion.a>
          </div>
        )}
      </div>
    </motion.div>
  );
};
